import React, { Component } from 'react'
import ProjectMonSta from '../components/ProjectMonSta'
import API_URL from '../../../common/url';


const config = {
    loadDataUrl: API_URL.dashboard.queryStatisticsInvSiteAmounts,
    exportUrl: API_URL.dashboard.exportStatisticsInvSiteAmounts,
    statisticalType: 'Type_Random',
    title:'入组数',
}
export default class PracticalJoinNum extends Component {
    render() {
        const { title } = this.props
        return (
            <ProjectMonSta title={title} config={config}></ProjectMonSta>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/homePage/statement/practicalJoinNum.js